import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ReportsList } from "@/components/wisdrop/ReportsList";
import { ReportFormModal } from "@/components/wisdrop/ReportFormModal";

export default function Wisdrop() {
  const [showReportModal, setShowReportModal] = useState(false);
  const [editingReport, setEditingReport] = useState(null);

  const handleCreateReport = () => {
    setEditingReport(null);
    setShowReportModal(true);
  };

  const handleEditReport = (report: any) => {
    setEditingReport(report);
    setShowReportModal(true);
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Wisdrop</h1>
        </div>
        <Button onClick={handleCreateReport}>
          <Plus className="h-4 w-4 mr-2" />
          New Report
        </Button>
      </div>

      <ReportsList onEditReport={handleEditReport} />

      <ReportFormModal
        open={showReportModal}
        onOpenChange={setShowReportModal}
        editingReport={editingReport}
      />
    </div>
  );
}